import axios from 'axios';
import { baseUrl, HttpMethods } from '../../../../base';
import type { IDeleteProjectAssetService, IGetProjectAssetsService, IPostProjectAssetService } from './types';

export async function getProjectAssets({ params, projectId }: IGetProjectAssetsService) {
  const res = await axios.request({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/projects/${projectId}/assets`,
    params,
  });
  return res.data;
}

export async function deleteProjectAsset({ assetId }: IDeleteProjectAssetService) {
  const res = await axios.request({
    method: HttpMethods.DELETE,
    url: `${baseUrl.SHERPA}/assets/${assetId}`,
  });
  return res.data;
}

export async function postProjectAsset({ projectId, data }: IPostProjectAssetService) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/projects/${projectId}/asset/save`,
    data,
  });

  return res.data;
}
